export const LightThemeColors = {
  primary: { main: "#2C6150", light: "#C6E5F8", dark: "#1A7AAA" },
  secondary: { main: "#6691E6", light: "#C3D7EC", dark: "#dedee3" },
  background: {
    default: "#F9FAFA",
    light: "#F1F2F3",
  },
  text: {
    primary: "#0C0C0E",
    secondary: "#0C0C0E",
  },
  chip: {
    greenShade: "#57A7731A",
    redShade: "#E561521A",
    greenText: "#57A773",
    redText: "#E56152",
  },
  button: {
    main: "#2C6150",
  },
  badges: {
    gray: {
      background: "hsla(0, 0%, 98%, 1)", // Light Gray
      text: "hsla(220, 10%, 50%, 1)", // Dark Gray
      border: "hsla(0, 0%, 0%, 0.05)",
    },
    blue: {
      background: "hsla(207, 90%, 94%, 1)", // Blue
      text: "hsla(0, 0%, 15%, 1)", // Dark Black/Gray
      border: "hsla(224, 59%, 30%, 0.15)",
    },
    yellow: {
      background: "hsla(35, 100%, 95%, 1)", // Yellow
      text: "hsla(1, 50%, 25%, 1)",
      border: "hsla(35, 100%, 20%, 0.15);",
    },
    red: {
      background: "hsla(0, 80%, 96%, 1)", // Red
      text: "hsla(35, 100%, 20%, 1)",
      border: "hsla(35, 100%, 20%, 0.15)",
    },
  },
  timeAllocation: {
    surgery: "hsla(220, 50%, 40%, 1)", // Dark Blue
    tat: "hsla(210, 80%, 70%, 1)", // Light Blue
    collectable: "hsla(220, 10%, 80%, 1)", // Gray
    unutilized: "hsla(0, 0%, 90%, 1)", // Light Gray
    errorContent: "hsla(1, 50%, 25%, 1)",
    warningContent: "hsla(35, 100%, 20%, 1)",
  },
};
